import { render } from "./FullscreenButton.vue?vue&type=template&id=2c67df8b&scoped=true"
import script from "./FullscreenButton.vue?vue&type=script&lang=js"
export * from "./FullscreenButton.vue?vue&type=script&lang=js"

import "./FullscreenButton.vue?vue&type=style&index=0&id=2c67df8b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c67df8b"]])

export default __exports__